<template>
  <div>
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <p class="blockTitleP" style="display:inline-block;">
          {{ $t('yhubReport.Dailystatistics') }}
          <el-button align="right" style="text-align: center;float:right;" class="filter-item" type="primary" icon="el-icon-download" @click="downDeviceSummary" />
        </p>
        <div class="pane_content overhiden SummaryWarp">
          <div class="pane_content" style="border: 1px solid #F5F7FA;width:100%;margin-top:10px;margin-bottom:10px;position:relative;">
            <div v-if="isShowWorkTimePop" class="WorkTimeWarp">
              <p>{{ $t('yhubReport.workTime') }}</p>
            </div>
            <div v-if="isShowUsedTimePop" class="usedTimeWarp">
              <p>{{ $t('yhubReport.usedTime') }}</p>
            </div>
            <table border="1" style="width:100%;text-align: center;line-height: 33px;font-size: 14px;color: #606266;border: none;border-collapse:collapse;">
              <thead style="line-height: 40px;">
                <th>{{ $t('yhubReport.Date') }}</th>
                <th>{{ $t('yhubReport.WorkingHours') }}<i class="el-icon-question" @mouseover="isShowWorkTimePop=true" @mouseout="isShowWorkTimePop=false" /></th>
                <th>{{ $t('yhubReport.UseTime') }}<i class="el-icon-question" @mouseover="isShowUsedTimePop=true" @mouseout="isShowUsedTimePop=false" /></th>
                <th>{{ $t('yhubReport.Discharge') }}</th>
                <th>{{ $t('basicinfo.DisCharged') }}(kWh)</th>
                <th>{{ $t('yhubReport.ChargingTime') }}</th>
                <th>{{ $t('yhubReport.Charge') }}</th>
                <th>{{ $t('basicinfo.Charged') }}(kWh)</th>
                <th>{{ $t('yhubReport.MinimumSOC') }}</th>
                <th>{{ $t('yhubReport.MinimumVoltage') }}</th>
                <th>{{ $t('yhubReport.MaximumTemperature') }}</th>
              </thead>
              <tbody style="color: #324057;" class="columnTable">
                <tr v-for="(item,index) in devicesSummaryList" :key="index">
                  <td>{{ item.monthDay }}</td>
                  <td>{{ item.workTimeZh }}</td>
                  <td>{{ item.usedTimeZh }} </td>
                  <td>{{ item.usedAhZh }}</td>
                  <td>{{ item.usingWhZh }}</td>
                  <td :title="item.chargeTime">{{ item.chargeTimeZh }}</td>
                  <td>{{ item.charedAhZh }} </td>
                  <td>{{ item.chargingWhZh }}</td>
                  <td>{{ item.minSocZh }}</td>
                  <td>{{ item.minVoltageZh }} </td>
                  <td>{{ item.maxTempratureZh }} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <el-table border="" :data="devicesSummaryList" :row-class-name="rowIndex" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="monthDay" min-width="10%" align="center" :label="$t('yhubReport.Date')" />
          <el-table-column min-width="40%" prop="1" :label="$t('yhubReport.Charts')" align="center">
            <template scope="scope">
              <div>
                <div class="pieChartDiv">
                  <yhub-pie-chart class="myPieChartFirst" :series-data="scope.row.pieSeriesData1" :height="pieHeight" :color-arr="colorArr1" />
                  <yhub-pie-chart class="myPieChartSecond" :series-data="scope.row.pieSeriesData2" :height="pieHeight" :color-arr="colorArr2" style="display:none;" />
                </div>
                <div style="position: absolute;text-align: left;bottom: 20px;width:100%;">
                  <!-- 使用率、充放电比 -->
                  <button class="changePieBtn firstBtn active" @click="changePieChart($event,1,scope.$index)">{{ $t("yhubReport.UsageRate") }}</button>
                  <button class="changePieBtn secondBtn" @click="changePieChart($event,2,scope.$index)">{{ $t("yhubReport.Ratio") }}</button>
                  <div class="el-icon-question" style="font-size:20px;" @mouseover="mouseoverQuestion(scope.$index)" @mouseout="mouseoutQuestion(scope.$index)" />
                  <!-- 选项卡处的问号弹窗 -->
                  <div class="questionPop">
                    <p v-if="$store.state.language=='en'||$store.state.language=='de'">{{ $t("yhubReport.Ratio") }} = {{ $t("yhubReport.chargeDischargeRatio") }}</p>
                    <p>{{ $t('yhubReport.DischargeInfo') }}</p>
                    <p>{{ $t('yhubReport.ChargeInfo') }}</p>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="50%" prop="2" :label="$t('yhubReport.AHDistribution')" align="center">
            <template scope="scope">
              <yhubReportBarChart :height="pieHeight" :data-detail="scope.row.odcEventDailyVoList1" />
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>

</template>

<script>
import { getOdcBMS, getHourReportBMS } from '@/api/yhub'
import { getDateAndWeek } from '@/utils/updateTime.js'
import yhubPieChart from '@/components/yhubPieChart'
import yhubReportBarChart from '@/components/yhubReportBarChart'
import i18n from '@/i18n'
import { parseTime, handleFloat } from '@/utils'
import { temChangeUnit } from '@/utils/temChange.js'

export default {
  components: {
    yhubPieChart,
    yhubReportBarChart
  },
  filters: {
    handleFloat
  },
  props: {
    listQuery: {
      type: Object,
      default: () => {}
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      devicesSummaryList: [],
      devicesSummaryList1: [],
      pieHeight: '200px',
      colorArr1: ['#a9d252', '#ff8c23', '#019ad6'],
      colorArr2: ['#e2c31d', '#33cccc'],
      isShowWorkTimePop: false,
      isShowUsedTimePop: false
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
    },
    devicesSummaryList1: {
      handler(newValue, oldValue) {
        this.devicesSummaryList1 = newValue // 把新值赋值给我们的属性数据
        // this.devicesSummaryList = this.devicesSummaryList1 // 把新值赋值给我们的属性数据
        // this.initChart() // 刷新echarts图表
      },
      deep: true
    },
    listQuery: {
      handler(newValue, oldValue) {
        this.queryList()
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted() {
    this.queryList()
  },
  methods: {
    queryList() {
      this.param = {
        endDate: this.listQuery.endDate,
        mcuId: this.listQuery.mcuId,
        startDate: this.listQuery.startDate,
        showAll: this.showAll
        // mcuId: '05d9ff333332534e43202848',
        // 'endDate': 1603209642737,
        // 'mcuId': '05d8ff333332534e43205055',
        // 'startDate': 1600704000000
      }
      getOdcBMS(this.param).then(res => { // Devices Summary
        if (res.resultCode === 1001) {
          var myRes = JSON.parse(JSON.stringify(res.resultModel))
          myRes.forEach((v, i) => {
            v.monthDay = getDateAndWeek(Number(v.monthDay), this.$store.state.language)
            v.pieSeriesData1 = []
            v.pieSeriesData1.push(
              { value: parseInt(v.chargeTime / 1000) || 0, name: i18n.t('yhubReport.ChargingTime'), key: 'charge', divClass: 'myPieChartFirst' },
              { value: parseInt((86400 - v.usedTime / 1000 - v.chargeTime / 1000)) || 0, name: i18n.t('basicinfo.Idled'), key: 'idel', divClass: 'myPieChartFirst' },
              { value: parseInt(v.usedTime / 1000) || 0, name: i18n.t('yhubReport.UseTime'), key: 'discharge', divClass: 'myPieChartFirst' }
            )
            v.pieSeriesData2 = []
            v.pieSeriesData2.push(
              { value: Math.round(v.charedAh / 100), name: i18n.t('QR.ChargedAH'), key: 'chargeAh', minSoc: v.minSoc, usedRate: v.usedRate, minVoltage: v.minVoltage, maxTemprature: v.maxTemprature, divClass: 'myPieChartSecond' },
              { value: Math.round(v.usedAh / 100), name: i18n.t('QR.dishargedAH'), key: 'dischargeAh', minSoc: v.minSoc, usedRate: v.usedRate, minVoltage: v.minVoltage, maxTemprature: v.maxTemprature, divClass: 'myPieChartSecond' }
            )
          })
          this.devicesSummaryList1 = myRes
          getHourReportBMS(this.param).then(response => {
            console.log('devicesSummaryList1---', this.devicesSummaryList1)
            if (response.resultCode == 1001) {
              // console.log('getHourReport1------', this.devicesSummaryList1)
              // 当两个数组长度不一致时，取短
              if (this.devicesSummaryList1.length > response.resultModel.length) {
                this.devicesSummaryList1 = this.devicesSummaryList1.splice(0, response.resultModel.length)
              } else if (this.devicesSummaryList1.length < response.resultModel.length) {
                response.resultModel = response.resultModel.splice(0, this.devicesSummaryList1.length)
              }
              // console.log('getHourReport1------', this.devicesSummaryList1)
              // console.log('response.resultModel------', response.resultModel)
              this.devicesSummaryList1.forEach((m, mi) => {
                // console.log('response.resultModel[mi]--', response.resultModel[mi])
                if (m.chargingWh < 0 || !m.chargingWh)m.chargingWh = 0
                if (m.usingWh < 0 || !m.usingWh)m.chargingWh = 0
                m.workTimeZh = parseInt((m.workTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((m.workTime % (1000 * 60 * 60)) / (60 * 1000)) + ' min'
                m.usedTimeZh = parseInt((m.usedTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((m.usedTime % (1000 * 60 * 60)) / (60 * 1000)) + ' min'
                m.usedAhZh = handleFloat(m.usedAh / 100) + ' Ah'
                m.usingWhZh = handleFloat(m.usingWh / 100000) + ' kWh'
                m.chargeTimeZh = parseInt((m.chargeTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + ' h ' + parseInt((m.chargeTime % (1000 * 60 * 60)) / (60 * 1000)) + ' min'
                m.charedAhZh = handleFloat(m.charedAh / 100) + ' Ah'
                m.chargingWhZh = handleFloat(m.chargingWh / 100000) + ' kWh'
                m.minSocZh = Math.round(m.minSoc / 100) + ' %'
                m.minVoltageZh = m.minVoltage / 100 + ' V'
                m.maxTempratureZh = temChangeUnit(Math.round(m.maxTemprature / 100))

                response.resultModel.forEach((v, vi) => {
                  this.devicesSummaryList1[mi].odcEventDailyVoList1 = JSON.parse(response.resultModel[mi].jsonStr)
                })
              })
              this.devicesSummaryList = this.devicesSummaryList1
              this.$nextTick(() => {
                var arr = document.querySelectorAll('.questionPop')
                arr.forEach(v => {
                  v.style.display = 'none'
                })
              })
            }
          })
        }
      })
    },
    // 饼状图切换
    changePieChart(event, val, index) {
      // 当在监控点击切换的时候，加个延迟主动触发窗口变化，这样窗口改变性能分析页就不会发生图表大小有问题的情况了 【这里的代码是关键！！！】
      setTimeout(() => {
        const triggerResize = new Event('resize')
        window.dispatchEvent(triggerResize)
        console.log('triggerResize--', triggerResize)
      }, 0)

      var eventParent = event.target.nodeName == 'SPAN' ? event.target.parentElement.parentElement : event.target.parentElement
      var eventDiv = document.getElementsByClassName('pieChartDiv')[index]
      if (val == 1) {
        eventDiv.firstChild.style.display = 'block'
        eventDiv.lastChild.style.display = 'none'
        eventParent.firstChild.classList.add('active')
        // eventParent.lastChild.classList.remove('active')
        eventParent.querySelector('.changePieBtn:nth-child(2)').classList.remove('active')
      } else if (val == 2) {
        eventDiv.firstChild.style.display = 'none'
        eventDiv.lastChild.style.display = 'block'
        eventParent.firstChild.classList.remove('active')
        // eventParent.lastChild.classList.add('active')
        eventParent.querySelector('.changePieBtn:nth-child(2)').classList.add('active')
      }
    },
    mouseoverQuestion(index) {
      document.querySelectorAll('.questionPop')[index].style.display = 'block'
    },
    mouseoutQuestion(index) {
      document.querySelectorAll('.questionPop')[index].style.display = 'none'
    },
    rowIndex({ row, rowIndex }) {
      row.rowIndex = rowIndex
    },
    downDeviceSummary() { // 下载每日统计数据
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          i18n.t('yhubReport.Date'),
          i18n.t('yhubReport.WorkingHours'),
          i18n.t('yhubReport.UseTime'),
          i18n.t('yhubReport.Discharge'),
          i18n.t('basicinfo.DisCharged'),
          i18n.t('yhubReport.ChargingTime'),
          i18n.t('yhubReport.Charge'),
          i18n.t('basicinfo.Charged'),
          i18n.t('yhubReport.MinimumSOC'),
          i18n.t('yhubReport.MinimumVoltage'),
          i18n.t('yhubReport.MaximumTemperature')
        ]
        const filterVal = [
          'monthDay',
          'workTimeZh',
          'usedTimeZh',
          'usedAhZh',
          'usingWhZh',
          'chargeTimeZh',
          'charedAhZh',
          'chargingWhZh',
          'minSocZh',
          'minVoltageZh',
          'maxTempratureZh'
        ]
        const list = this.devicesSummaryList
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'deviceSummary',
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    }
  }
}

</script>
<style lang="scss" scoped>
.questionPop,.WorkTimeWarp,.usedTimeWarp{
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  // margin: -120px 0 0 160px;
  left: 120px;
  bottom: 40px;
  max-width: 100%;
}
.questionPop{
  width:100%;
}
.WorkTimeWarp,.usedTimeWarp{
  margin: 0;
  left: 10%;
  width: auto;
  bottom: auto;
  top: -50px;
}
.usedTimeWarp{
  left: 15%;
}
.changePieBtn{
  outline: none;    //消除默认点击蓝色边框效果
  height: 25px;
  padding: 0 10px;
  font-size: 14px;
  border-radius: 4px;
  border:1px solid #c2e7b0;
  background:#f0f9eb;
  margin-bottom: 10px;
  position: relative;
}
.changePieBtn:nth-of-type(1){
  // margin-right:10px;
  margin-left: calc(1% + 5px);
}
.active{
  border:1px solid #67c23a;
  background:#67c23a;
  color:white;
}
</style>
